const showMarkets = (event) => {
  const target = event.target
  const container = target.closest(".market-selector")
  container.classList.toggle("is-active")
}

window.showMarkets = showMarkets;

const menu = document.querySelector(".header-menu-mob-options")
//const blackModal = document.querySelector(".menuContainer")
const toggleMenu = () => {
  menu.classList.toggle("is-active")
  //blackModal.classList.toggle("is-active")
}
window.toggleMenu = toggleMenu;